// Scripting for distributor country blocks
document.addEventListener("DOMContentLoaded", function () {
    const distributorCountries = Array.from(
        document.querySelectorAll(".m-distributorCountry")
    );
    const distributorCountryContactButtons = Array.from(
        document.querySelectorAll(".m-distributorCountry__contact--button")
    );

    if (distributorCountries.length > 0) {
        // Hide and remove preload class from country content
        distributorCountries.forEach((distributorCountry) => {
            distributorCountry.style.display = "none";
            distributorCountry.classList.remove("--preload");
        });

        jQuery(".m-distributorToggle").click(function () {
            jQuery(this)
                .children(".m-distributorToggle__icon")
                .toggleClass("--toggled");
            let country = jQuery(this).data("country");
            jQuery("#toggle-" + country).toggleClass("--toggled");
            jQuery("#content-" + country).slideToggle();
            jQuery("#content-" + country).toggleClass("open");
        });

        distributorCountryContactButtons.forEach(
            (distributorCountryContactButton) => {
                distributorCountryContactButton.addEventListener(
                    "click",
                    function (e) {
                        e.stopPropagation();

                        //get address info for dialog box
                        const addressContainer =
                            distributorCountryContactButton.parentElement
                                .previousElementSibling;
                        const address = addressContainer.querySelector(
                            "h4.m-distributorCountry__content--company"
                        ).textContent;
                        const dialog = document.querySelector("#dialog-form");
                        let country =
                            distributorCountryContactButton.parentElement
                                .parentElement.parentElement
                                .previousElementSibling.dataset.country;
                        dialog.querySelector(
                            "h4.m-distributorDialog__title"
                        ).textContent = address;
                        dialog.querySelector(
                            "address.m-distributorDialog__address"
                        ).innerHTML = addressContainer.querySelector(
                            "address.m-distributorCountry__content--address"
                        ).innerHTML;
                        $("#input_14_11").val(address);
                        $("#input_14_10").val(country);

                        dialog.showModal();
                    }
                );
            }
        );

        jQuery(".m-distributorDialog__button").click(function () {
            let button = jQuery(this).parent().attr("id");
            document.getElementById(button).close();
            jQuery(".--toggled").removeClass("--toggled");
            jQuery(".open").slideToggle();
            jQuery(".open").toggleClass("open");
        });

        jQuery(document).on("click", ".o-distributorMap__button", function () {
            const dialog = $("#dialog-form");
            let country = jQuery(this).parent().prev().text();
            jQuery("#toggle-" + country).toggleClass("--toggled");
            jQuery("#toggle-" + country)
                .children(".m-distributorToggle__icon")
                .toggleClass("--toggled");
            jQuery("#content-" + country).slideToggle();

            const address = jQuery(this).parent().parent().html();

            let distributor = jQuery(this).parent().parent().prev().text();
            $("h4.m-distributorDialog__title", dialog).text(distributor);
            $("address.m-distributorDialog__address", dialog).html(address);

            $("#input_14_11").val(distributor);
            $("#input_14_10").val(country);

            jQuery(".o-distributorMap__button", dialog).attr(
                "style",
                "display:none"
            );
            document.getElementById("dialog-form").showModal();
        });

        // Hard to implement because the .o-distributorMap__button gets added later when the user clicks on a map icon
        // const distributorMap = document.querySelector(".o-distributorsMap");
        // distributorMap.addEventListener("click", function () {
        //     const distributorMapButtons = Array.from(
        //         document.querySelectorAll(".o-distributorMap__button")
        //     );

        //     if (distributorMapButtons.length > 0) {
        //         distributorMapButtons.forEach((distributorMapButton) => {
        //             distributorMapButton.addEventListener("click", function () {
        //                 const dialog = document.querySelector("#dialog-form");
        //                 let country =
        //                     this.parentElement.previousElementSibling
        //                         .textContent;
        //                 const address =
        //                     distributorMapButton.parentElement.parentElement
        //                         .innerHTML;
        //                 let distributor =
        //                     distributorMapButton.parentElement.parentElement
        //                         .previousElementSibling.textContent;
        //                 dialog.querySelector(
        //                     "h4.m-distributorDialog__title"
        //                 ).textContent = distributor;
        //                 dialog.querySelector(
        //                     "address.m-distributorDialog__address"
        //                 ).innerHTML = address;

        //                 document.querySelector("#input_14_11").value =
        //                     distributor;
        //                 document.querySelector("#input_14_10").value = country;

        //                 dialog.querySelector(
        //                     ".o-distributorMap__button"
        //                 ).style.display = "none";

        //                 dialog.showModal();
        //             });
        //         });
        //     }
        // });

        //country nav scroll amount
        const catNavLinks = Array.from(
            document.querySelectorAll("a.o-categoryNav__link")
        );

        catNavLinks.forEach((catNavLink) => {
            catNavLink.addEventListener("click", function (e) {
                e.preventDefault();

                let primaryNav = document.querySelector(".o-primaryNav");
                let navHeight = false;
                if (primaryNav) {
                    navHeight = primaryNav.offsetHeight;
                }
                if (!navHeight) {
                    navHeight =
                        document.querySelector(".o-simpleNav").offsetHeight;
                }
                let navLink = e.currentTarget.hash;

                let linkHeight = document.querySelector(navLink).offsetTop;
                let scrollAmount = linkHeight - navHeight;

                window.scrollTo({
                    top: scrollAmount,
                    left: 0,
                    behavior: "smooth",
                });
            });
        });
    }
});
